import React from 'react';
import {
  Alert,
  AlertTitle,
  Skeleton,
} from '@mui/material';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import EditDetailForm from '../profile-details-form';

type UserProfileEditViewProps = {
  partner: Partner
  isLoading: boolean
  partnerError: any
  onSubmit: (data: any) => void
  submissionError: boolean
  onCancel?: () => void
};

const EditView = ({
  partnerError,
  isLoading,
  partner,
  onSubmit,
  submissionError,
  onCancel = undefined,
}: UserProfileEditViewProps) => {
  if (isLoading || !partner) {
    return (
      <Skeleton variant="rounded" height={500} />
    );
  }

  if (partnerError) {
    return (
      <Alert severity="error">
        <AlertTitle>User Error</AlertTitle>
        There was an error getting user.
      </Alert>
    );
  }

  return (
    <EditDetailForm
      title="Edit About"
      partner={partner}
      submissionError={submissionError}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  );
};

export default EditView;
